<app-modal>
    <div class="flex flex-col space-y-3">
        <button
            type="button"
            class="flex gap-2 items-center"
            (click)="phoneClick()"
        >
            <img
                class="h-8"
                src="assets/svg/call_0884c2.svg"
                alt="Phone icon"
            />
            <span class="!m-0"
                >Contact via Phone {{ contactConstants.phoneNumber }}</span
            >
        </button>
        <button
            type="button"
            class="flex gap-2 items-center"
            (click)="emailClick()"
        >
            <img class="h-8" src="assets/svg/email.svg" alt="Email icon" />
            <span class="!m-0">Contact via Email</span>
        </button>
    </div>
</app-modal>
